<template>
  <div style="padding: 10px">
    <div style="margin: 10px 0">
      <el-button type="primary" @click="add" v-if="this.userId === 1">新增</el-button>
      <el-input v-model="search.accountName" placeholder="账号名" @keyup.enter.native="load" style="width: 10%"
                clearable></el-input>
      <el-select v-model="search.parentRoleId" clearable filterable placeholder="请选择父账号" style="width: 10%">
        <el-option
            v-for="item in parentIdDict"
            :key="item.parentRoleId"
            :label="item.accountName"
            :value="item.parentRoleId">
        </el-option>
      </el-select>
      <el-select v-model="search.child" clearable filterable placeholder="是否子账号" style="width: 10%">
        <el-option
            v-for="item in childDict"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey">
        </el-option>
      </el-select>
      <el-select v-model="search.horse" clearable filterable placeholder="可否打马" style="width: 10%">
        <el-option
            v-for="item in childDict"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey">
        </el-option>
      </el-select>
      <el-select v-model="search.clubCode" clearable filterable placeholder="计划俱乐部" style="width: 10%">
        <el-option
            v-for="item in clubCodeDict"
            :key="item.clubCode"
            :label="item.clubName"
            :value="item.clubCode">
        </el-option>
      </el-select>
      <el-select v-model="search.realClubCode" clearable filterable placeholder="当前俱乐部" style="width: 10%">
        <el-option
            v-for="item in clubCodeDict"
            :key="item.clubCode"
            :label="item.clubName"
            :value="item.clubCode">
        </el-option>
      </el-select>
      <el-button type="primary" style="margin-left: 5px" @click="load">查询</el-button>
      <el-button style="margin-left: 5px" @click="resetData">重置</el-button>
    </div>
    <div style="margin: 10px 0">
      <el-button type="primary" style="margin-left: 5px" @click="initTenKing">十殿初始化</el-button>
      <el-button type="primary" style="margin-left: 5px" @click="noTenKing('初始化')">十殿没打</el-button>
      <el-button type="primary" style="margin-left: 5px" @click="noEightTenKing">十殿没过8</el-button>
      <el-button type="primary" style="margin-left: 5px" @click="noTenKing('已过8')">十殿已过8</el-button>
      <el-button type="primary" style="margin-left: 5px" @click="noTenKing('pass')">十殿PASS</el-button>
      <el-button type="primary" style="margin-left: 5px" title="查询计划俱乐部和实际俱乐部不符的玩家"
                 @click="abnormalClub">俱乐部异常
      </el-button>
      <el-button type="primary" style="margin-left: 5px" @click="updateClubBatch">批量修改俱乐部</el-button>
      <el-button type="primary" style="margin-left: 5px" @click="updateTenKingBatch">批量更新十殿</el-button>
    </div>
    <el-table
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 100%">
      <el-table-column
          prop="accountName"
          label="账号名">
      </el-table-column>
      <el-table-column prop="roleId" label="角色ID">
        <template #default="{row}">
        <span
            class="copyable-text"
            @click="copyToClipboard(row.roleId)"
        >
          {{ row.roleId }}
          <i class="el-icon-document-copy"></i>
        </span>
        </template>
      </el-table-column>
      <el-table-column
          label="修改十殿"
          width="200">
        <template #default="{row}">
          <el-switch
              v-model="row.tenKingStatus"
              :active-value="1"
              :inactive-value="2"
              active-text="已过8"
              inactive-text="没过8"
              @change="handleTenKingChange(row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
          prop="clubCode"
          :formatter="clubCodeFormatter"
          label="计划俱乐部">
      </el-table-column>
      <el-table-column
          prop="realClubCode"
          :formatter="realClubCodeFormatter"
          label="实际俱乐部">
      </el-table-column>
      <el-table-column
          prop="child"
          :formatter="childFormatter"
          label="是否小号">
      </el-table-column>
      <el-table-column
          prop="parentRoleId"
          :formatter="parentIdFormatter"
          label="父账号">
      </el-table-column>
      <el-table-column label="操作" width="270px" v-if="this.userId === 1">
        <template #default="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini"
                     @click="handleTransfer(scope.row)"
                     :loading="transferLoading"
          >
            转网页
          </el-button>
          <el-upload
              class="upload-inline"
              action="https://www.aseerdd.shop/api/xyzwToken/upload"
              :data="{ roleId: scope.row.roleId }"
              :before-upload="(file) => beforeUpload(file, scope.row)"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :show-file-list="false"
          >
            <el-button
                size="mini"
                type="success"
                :loading="uploadLoading && currentUploadRow === scope.row.roleId"
            >
              上传Bin
            </el-button>
          </el-upload>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin: 10px 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
    <!--新增编辑表单-->
    <el-dialog title="新增/编辑" v-model="dialogVisible" width="30%">
      <el-form :model="form">
        <el-form-item label="账号名">
          <el-input v-model="form.accountName"></el-input>
        </el-form-item>
        <el-form-item label="角色ID">
          <el-input v-model="form.roleId"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="form.password"></el-input>
        </el-form-item>
        <el-form-item label="父账号ID">
          <el-input v-model="form.parentRoleId"></el-input>
        </el-form-item>
        <el-form-item label="计划俱乐部" style="width: 100%">
          <el-select v-model="form.clubCode" placeholder="计划俱乐部" filterable>
            <el-option
                v-for="item in clubCodeDict"
                :key="item.clubCode"
                :label="item.clubName"
                :value="item.clubCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="实际俱乐部">
          <el-select v-model="form.realClubCode" placeholder="实际俱乐部" filterable>
            <el-option
                v-for="item in clubCodeDict"
                :key="item.clubCode"
                :label="item.clubName"
                :value="item.clubCode">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="save">确 定</el-button>
          </span>
      </template>
    </el-dialog>

    <el-dialog title="批量更新俱乐部" v-model="dialogClubUpdate" width="50%">
      <el-form :model="clubForm">
        <el-form-item label="变更类型" style="width: 100%">
          <el-radio-group v-model="clubForm.type">
            <el-radio :label="1">计划俱乐部</el-radio>
            <el-radio :label="2">实际俱乐部</el-radio>
            <el-radio :label="3">全部更新</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="俱乐部信息">
          <el-select v-model="clubForm.clubCode" placeholder="目标俱乐部" filterable clearable>
            <el-option
                v-for="item in clubCodeDict"
                :key="item.clubCode"
                :label="item.clubName"
                :value="item.clubCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="成员">
          <!-- 修复：将 remote-method 绑定到方法，而不是字符串 -->
          <el-select
              v-model="clubForm.ids"
              multiple
              placeholder="选择要变更的成员"
              filterable
              clearable
              :remote="true"
              :remote-method="handleSearchAccounts"
              :loading="searchAccountLoading"
              @focus="handleAccountSelectFocus"
          >
            <el-option
                v-for="item in filteredAccountOptions"
                :key="item.id"
                :label="item.accountName"
                :value="item.id">
              <span>{{ item.accountName }} ({{ item.roleId }})</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogClubUpdate = false">取 消</el-button>
            <el-button type="primary" @click="updateClubs">确 定</el-button>
          </span>
      </template>
    </el-dialog>
    <el-dialog title="批量更新十殿" v-model="dialogTenKingUpdate" width="50%">
      <el-form :model="tenKingForm">
        <el-form-item label="变更类型" style="width: 100%">
          <el-radio-group v-model="tenKingForm.type">
            <el-radio :label="1">已过8</el-radio>
            <el-radio :label="2">没过8</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="成员">
          <!-- 修复：将 remote-method 绑定到方法，而不是字符串 -->
          <el-select
              v-model="tenKingForm.ids"
              multiple
              placeholder="选择要变更的成员"
              filterable
              clearable
              :remote="true"
              :remote-method="handleSearchAccounts"
              :loading="searchAccountLoading"
              @focus="handleAccountSelectFocus"
          >
            <el-option
                v-for="item in filteredAccountOptions"
                :key="item.id"
                :label="item.accountName"
                :value="item.id">
              <span>{{ item.accountName }} ({{ item.roleId }})</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogTenKingUpdate = false">取 消</el-button>
            <el-button type="primary" @click="updateTenKings">确 定</el-button>
          </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'accountInfo',
  components: {},
  data() {
    return {
      // 转移相关数据
      changeWsForm: {
        roleId: '',
        accountName: '',
        parentRoleId: ''
      },
      // 加载状态
      transferLoading: false,
      uploadLoading: false,
      currentUploadRow: null,
      // 搜索账号相关
      searchAccountLoading: false,
      accountOptions: [], // 存储搜索到的账号列表
      searchAccountKeyword: '', // 搜索关键词
      filteredAccountOptions: [], // 筛选后的账号列表

      dialogVisible: false,
      dialogClubUpdate: false,
      dialogTenKingUpdate: false,
      parentIdDict: [],
      childDict: [{"dictKey": 1, "dictValue": "是"}, {"dictKey": 0, "dictValue": "否"}],
      clubCodeDict: [],
      form: {
        createTime: '',
      },
      clubForm: {
        type: '',
        ids: [],
        clubCode: ''
      },
      tenKingForm: {
        type: '',
        ids: []
      },
      userId: '',
      loading: true,
      search: {},
      query: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],

      // 防抖计时器
      searchAccountDebounce: null
    }
  },
  created() {
    this.load()
    let userStr = sessionStorage.getItem("user") || "{}"
    let user = JSON.parse(userStr)
    this.userId = user.id;
  },
  mounted() {
    this.getClubCodeDict();
    this.getParentIdList();
  },
  methods: {
    // 处理远程搜索
    handleSearchAccounts(query) {
      this.searchAccountLoading = true;

      // 清除之前的防抖计时器
      if (this.searchAccountDebounce) {
        clearTimeout(this.searchAccountDebounce);
      }

      // 设置新的防抖计时器
      this.searchAccountDebounce = setTimeout(() => {
        this.performSearchAccount(query);
      }, 300);
    },

    // 实际执行搜索
    performSearchAccount(keyword) {
      request.get("/accountInfo/searchAccounts", {
        params: {
          accountName: keyword,
          limit: 20
        }
      }).then(res => {
        this.searchAccountLoading = false;
        if (res.code === '0') {
          this.accountOptions = res.data;
          this.filteredAccountOptions = res.data;
        } else {
          this.accountOptions = [];
          this.filteredAccountOptions = [];
        }
      }).catch(error => {
        this.searchAccountLoading = false;
        console.error('搜索账号失败:', error);
        this.accountOptions = [];
        this.filteredAccountOptions = [];
      });
    },

    // 账号选择框获得焦点时的处理
    handleAccountSelectFocus() {
      // 如果还没有数据，自动搜索前20条记录
      if (this.accountOptions.length === 0) {
        this.handleSearchAccounts('');
      }
    },

    // 原有方法
    handleTransfer(row) {
      this.transferLoading = true
      this.changeWsForm = {
        roleId: row.roleId,
        accountName: row.accountName,
        parentRoleId: row.parentRoleId
      }

      request.post("/accountInfoWs/save", this.changeWsForm)
          .then(response => {
            this.$message({
              type: 'success',
              message: '转移成功！'
            })
            this.load()
          })
          .catch(error => {
            console.error('转移失败:', error)
            this.$message({
              type: 'error',
              message: '转移失败，请稍后重试'
            })
          })
          .finally(() => {
            this.transferLoading = false
          })
    },

    handleTenKingChange(row) {
      this.tenKingForm.type = row.tenKingStatus;
      this.tenKingForm.ids = [row.id];
      this.updateTenKings();
    },

    async copyToClipboard(text) {
      const textToCopy = text.toString()

      if (navigator.clipboard && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(textToCopy)
          this.$message.success('复制成功')
          return
        } catch (err) {
          console.warn('现代Clipboard API失败，使用降级方案')
        }
      }

      const textArea = document.createElement('textarea')
      textArea.value = textToCopy
      textArea.style.position = 'fixed'
      textArea.style.opacity = '0'

      document.body.appendChild(textArea)
      textArea.select()

      try {
        const successful = document.execCommand('copy')
        if (successful) {
          this.$message.success('复制成功')
        } else {
          this.$message.error('复制失败')
        }
      } catch (err) {
        this.$message.error('复制失败')
      } finally {
        document.body.removeChild(textArea)
      }
    },

    add() {
      this.dialogVisible = true
      this.form = {}
    },

    handleEdit(row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.dialogVisible = true
    },

    save() {
      this.loading = true;
      if (this.form.id) {
        request.post("/accountInfo/update", this.form).then(res => {
          if (res.code === '0') {
            this.$message({
              type: "success",
              message: res.msg
            })
          } else {
            this.$message({
              type: "error",
              message: res.msg
            })
          }
          this.load()
          this.loading = false
          this.dialogVisible = false
        })
      } else {
        request.post("/accountInfo/save", this.form).then(res => {
          if (res.code === '0') {
            this.$message({
              type: "success",
              message: "新增成功"
            })
          } else {
            this.$message({
              type: "error",
              message: res.msg
            })
          }
          this.form = '';
          this.load();
          this.loading = false
          this.dialogVisible = false
        })
      }
    },

    exportUser() {
      location.href = "http://182.92.223.123:9090/saltedFishSource/export";
    },

    resetData() {
      this.search = {}
      this.load()
    },

    getParentIdList() {
      request.get("/accountInfo/parentList", {}).then(res => {
        this.parentIdDict = res.data
      })
    },

    getClubCodeDict() {
      request.get("/clubInfo/listNoPageForWeb", {}).then(res => {
        this.clubCodeDict = res.data
        this.clubCodeDict.push({clubName: "无", clubCode: -1})
        this.clubCodeDict.push({clubName: "不需要", clubCode: -2})
      })
    },

    initTenKing() {
      request.get("/accountInfo/initTenKing", {}).then(res => {
        if (res.code === '0') {
          this.$message({
            type: "success",
            message: res.msg
          })
        } else {
          this.$message({
            type: "error",
            message: res.msg
          })
        }
      })
    },

    updateClubBatch() {
      this.clubForm = {}
      this.dialogClubUpdate = true;
    },

    updateClubs() {
      this.loading = true;
      request.post("/accountInfo/updateBatch", this.clubForm).then(res => {
        if (res.code === '0') {
          this.$message({
            type: "success",
            message: res.msg
          })
        } else {
          this.$message({
            type: "error",
            message: res.msg
          })
        }
        this.load()
        this.loading = false
        this.dialogClubUpdate = false
      })
    },

    updateTenKingBatch() {
      this.tenKingForm = {type: 1}
      this.dialogTenKingUpdate = true;
    },

    updateTenKings() {
      this.loading = true;
      request.post("/accountInfo/updateTenKingBatch", this.tenKingForm).then(res => {
        if (res.code === '0') {
          this.$message({
            type: "success",
            message: res.msg
          })
        } else {
          this.$message({
            type: "error",
            message: res.msg
          })
        }
        this.load()
        this.loading = false
        this.dialogTenKingUpdate = false
      })
    },

    noTenKing(value) {
      this.search = {}
      this.search.child = 0;
      this.search.tenKing = value;
      this.load();
    },

    noEightTenKing() {
      this.search = {}
      this.search.child = 0;
      this.search.noEightTenKing = 1;
      this.load();
    },

    abnormalClub() {
      this.search = {}
      this.search.abnormalClub = 1;
      this.load();
    },

    load() {
      this.loading = true
      const searchForm = {...this.search}
      let obj = Object.assign(searchForm, this.query)
      let reqData = {
        ...obj
      }
      reqData.current = this.currentPage
      reqData.size = this.pageSize
      request.get("/accountInfo/list", {
        params: reqData
      }).then(res => {
        this.loading = false
        this.tableData = res.data.records
        this.total = res.data.total

        this.tableData.forEach(row => {
          if (row.tenKing === '已过8') {
            row.tenKingStatus = 1;
          } else {
            row.tenKingStatus = 2;
          }
        })
      })
    },

    beforeUpload(file, row) {
      this.currentUploadRow = row.roleId
      const isBin = file.name.toLowerCase().endsWith('.bin')
      if (!isBin) {
        this.$message.error('只能上传.bin格式的文件')
        this.currentUploadRow = null
        return false
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB')
        this.currentUploadRow = null
        return false
      }
      this.uploadLoading = true
      return true
    },

    handleUploadSuccess(response, file) {
      this.uploadLoading = false
      this.currentUploadRow = null
      if (response.code === "0" || response.success) {
        this.$message.success('文件上传成功！')
      } else {
        this.$message.error(response.message || '上传失败')
      }
    },

    handleUploadError(err, file) {
      this.uploadLoading = false
      this.currentUploadRow = null
      console.error('上传失败:', err)
      this.$message.error('文件上传失败，请稍后重试')
    },

    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.load()
    },

    handleCurrentChange(pageNum) {
      this.currentPage = pageNum
      this.load()
    },

    clubCodeFormatter(row) {
      if (row.clubCode === null || row.clubCode === -1) {
        return "无";
      }
      const list = this.clubCodeDict;
      if (list) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].clubCode === row.clubCode) {
            return list[i].clubName
          }
        }
      }
    },

    realClubCodeFormatter(row) {
      if (row.realClubCode === null || row.realClubCode === -1) {
        return "无";
      }
      const list = this.clubCodeDict;
      if (list) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].clubCode === row.realClubCode) {
            return list[i].clubName
          }
        }
      }
    },

    childFormatter(row) {
      if (row.child === null) {
        return "无";
      }
      const list = this.childDict;
      if (list) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].dictKey === row.child) {
            return list[i].dictValue
          }
        }
      }
    },

    parentIdFormatter(row) {
      if (row.parentRoleId === null) {
        return "无";
      }
      const list = this.parentIdDict;
      if (list) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].roleId === row.parentRoleId) {
            return list[i].accountName
          }
        }
      }
    },
  }
}
</script>
<style>
/* 内联上传按钮样式 */
.upload-inline {
  display: inline-block;
  margin-left: 10px;
}
</style>
